<div class="header">
  <div class="title">
    <div class="title-text">Laser</div>
  </div>
  <span class="message">* populated from PatientNow</span>
</div>
@if (options.value()) {
  <hr class="divider" />
  <div [formGroup]="form" class="form-group">
    <div formArrayName="treatments" class="controls">
      @for (control of form.controls.treatments.controls; track $index) {
        <fb-expansion-panel [expanded]="shouldBeExpanded($index, control.value, options.value().treatment)">
          <fb-expansion-panel-header>{{ control.value.date | date: 'MM/dd/yyyy' }}</fb-expansion-panel-header>
          <fb-expansion-panel-content>
            <fb-laser-treatment-control
              [formControl]="control"
              [equipmentOptions]="options.value().equipment"
              [procedureTypeOptions]="options.value().procedureType"
              [laserOptions]="options.value().laser"
              [labels]="options.value().company"
              [markerTarget]="markerTargets()[$index]"
              [rowIndex]="$index"
            />
          </fb-expansion-panel-content>
        </fb-expansion-panel>
        <hr class="divider" />
      }
    </div>
  </div>
  <button type="button" class="action" (click)="addLaserTreatment()">
    <rx-icon name="icon-circle-plus-2" class="action-icon" />
    <span class="action-label">Add Laser</span>
  </button>
} @else if (options.error()) {
  <span class="message">Unexpected error occurred</span>
}
